import qs from 'query-string';

/** The page in the URL (`?page=`), or 1 when it is missing, zero or not a number. */
export const getValidatedPageParam = (): number => {
  const params = qs.parse(window.location.search, { parseNumbers: false });
  let page = 1;

  if (params.page && !isNaN(Number(params.page)) && Number(params.page) !== 0) {
    page = Number(params.page);
  }

  return page;
};

/** The rows per page in the URL (`?limit=`), or 45 when it is missing, zero, not a number or above 200. */
export const getValidatedLimitParam = (): number => {
  const params = qs.parse(window.location.search, { parseNumbers: false });
  let limit = 45;

  if (params.limit && !isNaN(Number(params.limit)) && Number(params.limit) !== 0 && Number(params.limit) <= 200) {
    limit = Number(params.limit);
  }

  return limit;
};

/** The page buttons to show: the first, the last and the ones around the current page, with "..." for gaps. */
export function paginate(page: number, pagesCount: number): string[] {
  const rangeStart = page - 1;
  const rangeEnd = page + 2;
  const shown: number[] = [];
  const items: string[] = [];
  let previous: number | undefined;

  for (let current = 1; current <= pagesCount; current++) {
    if (current === 1 || current === pagesCount || (current >= rangeStart && current < rangeEnd)) {
      shown.push(current);
    }
  }

  for (const current of shown) {
    if (previous) {
      if (current - previous === 2) {
        items.push((previous + 1).toString());
      } else if (current - previous !== 1) {
        items.push('...');
      }
    }

    items.push(current.toString());
    previous = current;
  }

  return items;
}
